import React from 'react'

import {createLargeSvgIcon} from './utils'

export default createLargeSvgIcon(
  <>
    <g clipPath="url(#clip0)">
      <g clipPath="url(#clip1)">
        <path
          d="M0.92166 16.1682C0.92166 11.0064 0.92166 8.42554 1.92621 6.45401C2.80983 4.71979 4.21979 3.30984 5.95401 2.42621C7.92554 1.42166 10.5064 1.42166 15.6682 1.42166V1.42166C20.83 1.42166 23.4109 1.42166 25.3824 2.42621C27.1166 3.30984 28.5266 4.71979 29.4102 6.45401C30.4147 8.42554 30.4147 11.0064 30.4147 16.1682V16.1682C30.4147 21.33 30.4147 23.9109 29.4102 25.8824C28.5266 27.6166 27.1166 29.0266 25.3824 29.9102C23.4109 30.9147 20.83 30.9147 15.6682 30.9147V30.9147C10.5064 30.9147 7.92554 30.9147 5.95401 29.9102C4.21979 29.0266 2.80983 27.6166 1.92621 25.8824C0.92166 23.9109 0.92166 21.33 0.92166 16.1682V16.1682Z"
          fill="#FCDA30"
        />
        <path
          d="M8.20091 8.60087L-5.16324 26.1274L-1.57409 30.2351L8.42162 17.0601L7.42417 24.2611L13.0238 26.1716L19.6904 15.2944C19.367 17.3531 18.8325 22.0145 23.3733 23.3911C30.3815 25.5156 36.4769 12.9467 39.3419 6.53212L35.3011 4.39559C32.1822 10.9686 27.2708 18.319 25.3548 17.7848C23.4486 17.2534 25.1728 11.0914 26.2847 7.11737L26.302 7.05551L20.1061 4.9566L12.7274 17.0642L13.7243 10.5113L8.20091 8.60087Z"
          fill="#3D3C37"
        />
      </g>
      <mask height="23" id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" width="23" x="15" y="16">
        <path
          d="M18.2593 20.5968L24.158 17.1271C25.7443 16.1939 27.7119 16.1939 29.2983 17.1271L35.1969 20.5968C36.7452 21.5076 37.6959 23.1698 37.6959 24.9661V29.4901C37.6959 31.2864 36.7452 32.9486 35.1969 33.8594L29.2983 37.3292C27.7119 38.2623 25.7443 38.2623 24.158 37.3292L18.2593 33.8594C16.711 32.9486 15.7604 31.2864 15.7604 29.4901V24.9661C15.7604 23.1698 16.711 21.5076 18.2593 20.5968Z"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M26.7281 15.6152L15.7604 22.0668L26.7281 28.5184L37.6959 22.0668L26.7281 15.6152Z"
          fill="url(#paint0_linear)"
        />
        <path d="M15.7604 32.3892V22.0668L26.7281 28.5184V38.841L15.7604 32.3892Z" fill="url(#paint1_radial)" />
        <path d="M37.6959 32.3894V22.0668L26.7281 28.5184V38.841L37.6959 32.3894Z" fill="url(#paint2_radial)" />
        <path
          clipRule="evenodd"
          d="M21.1008 16.8095L32.473 23.5714C33.3112 24.0697 33.8249 24.9728 33.8249 25.948V37.5507H30.5991V27.7829C30.5991 26.8077 30.0854 25.9047 29.2472 25.4063L19.4522 19.5822L21.1008 16.8095Z"
          fill="url(#paint3_radial)"
          fillRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear"
        x1="26.2894"
        x2="27.016"
        y1="16.312"
        y2="26.5861"
      >
        <stop stopColor="#FFE7C2" />
        <stop offset="1" stopColor="#E3B673" />
      </linearGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(26.2483 38.0666) rotate(-130.069) scale(12.1399 11.3741)"
        gradientUnits="userSpaceOnUse"
        id="paint1_radial"
        r="1"
      >
        <stop stopColor="#CA8D32" />
        <stop offset="1" stopColor="#F2C888" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(23.7626 34.5827) rotate(-27.4023) scale(13.8774 12.5411)"
        gradientUnits="userSpaceOnUse"
        id="paint2_radial"
        r="1"
      >
        <stop stopColor="#C4892F" />
        <stop offset="1" stopColor="#E6BE81" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(19.6313 19.8088) rotate(30.7627) scale(15.7669 11.5431)"
        gradientUnits="userSpaceOnUse"
        id="paint3_radial"
        r="1"
      >
        <stop stopColor="#FFF6E8" />
        <stop offset="0.677761" stopColor="#FFF9EF" />
        <stop offset="1" stopColor="#F0DBBC" />
      </radialGradient>
      <clipPath id="clip0">
        <rect fill="white" height="40" transform="translate(0 0.5)" width="40" />
      </clipPath>
      <clipPath id="clip1">
        <path
          d="M0.92166 16.1682C0.92166 11.0064 0.92166 8.42554 1.92621 6.45401C2.80983 4.71979 4.21979 3.30984 5.95401 2.42621C7.92554 1.42166 10.5064 1.42166 15.6682 1.42166V1.42166C20.83 1.42166 23.4109 1.42166 25.3824 2.42621C27.1166 3.30984 28.5266 4.71979 29.4102 6.45401C30.4147 8.42554 30.4147 11.0064 30.4147 16.1682V16.1682C30.4147 21.33 30.4147 23.9109 29.4102 25.8824C28.5266 27.6166 27.1166 29.0266 25.3824 29.9102C23.4109 30.9147 20.83 30.9147 15.6682 30.9147V30.9147C10.5064 30.9147 7.92554 30.9147 5.95401 29.9102C4.21979 29.0266 2.80983 27.6166 1.92621 25.8824C0.92166 23.9109 0.92166 21.33 0.92166 16.1682V16.1682Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </>,
  'Collaboration',
)
